/**
 * API Configuration
 */

/**
 * @deprecated Mailgun configuration - DEPRECATED
 * This configuration has been replaced by the secure Outreach API.
 * Email sending now uses JWT authentication via the Outreach API client.
 * This export is maintained for backward compatibility only.
 */
export const mailgunConfig = {
  apiKey: "DEPRECATED - Use Outreach API",
  domain: "DEPRECATED - Use Outreach API", 
  username: "DEPRECATED - Use Outreach API",
  password: "DEPRECATED - Use Outreach API",
};

/**
 * YouTube API configuration
 */
export const YOUTUBE_API_KEY =
  process.env.REACT_APP_YOUTUBE_API_KEY || '';

/**
 * API Gateway configuration for YouTube token retrieval
 */
export const youtubeAuthConfig = {
  tokenUrl: process.env.REACT_APP_API_GATEWAY_YOUTUBE_TOKEN_URL || '',
  apiKey:
    process.env.REACT_APP_API_KEY ||
    process.env.REACT_APP_X_API_KEY ||
    '',
};

/**
 * Spotify API configuration
 */
export const spotifyConfig = {
  clientId: process.env.REACT_APP_SPOTIFY_CLIENT_ID || "your-spotify-client-id",
  clientSecret:
    process.env.REACT_APP_SPOTIFY_CLIENT_SECRET || "your-spotify-client-secret",
};

/**
 * SimilarWeb API configuration
 */
export const similarwebConfig = {
  apiKey: process.env.REACT_APP_SIMILARWEB_API_KEY || "your-similarweb-api-key",
};

/**
 * OpenAI API configuration
 */
export const openAIKey =
  process.env.REACT_APP_OPENAI_API_KEY || "your-openai-api-key";

/**
 * Distro Nation API configuration
 */
export const dnApiConfig = {
  apiKey: process.env.REACT_APP_DN_API_KEY || "your-dn-api-key-here",
  baseUrl: process.env.REACT_APP_BASE_API_URL || "your-base-api-url-here",
};

/**
 * Financial API Gateway configuration
 */
export const financialApiConfig = {
  baseUrl:
    process.env.REACT_APP_FINANCIAL_API_GATEWAY_URL ||
    process.env.REACT_APP_FINANCIAL_API_BASE_URL ||
    "",
  sendReportPath:
    process.env.REACT_APP_FINANCIAL_API_SEND_REPORT_PATH ||
    "/financial/send-report",
  trackingDataPath:
    process.env.REACT_APP_FINANCIAL_API_TRACKING_PATH ||
    "/financial/tracking-data",
  batchSendPath:
    process.env.REACT_APP_FINANCIAL_API_BATCH_SEND_PATH ||
    "/financial/send-batch-report",
};

/**
 * API endpoints
 */
export const apiEndpoints = {
  usersList: process.env.REACT_APP_BASE_API_URL + "/dn_users_list",
  sendMail: process.env.REACT_APP_BASE_API_URL + "/send-mail",
};

/**
 * Newsletter SES API configuration
 */
export const newsletterApiConfig = {
  baseUrl:
    process.env.REACT_APP_NEWSLETTER_API_URL ||
    process.env.REACT_APP_FINANCIAL_API_GATEWAY_URL ||
    "https://9n32fp9ikd.execute-api.us-east-1.amazonaws.com/dev",
  sendPath:
    process.env.REACT_APP_NEWSLETTER_API_SEND_PATH ||
    "/newsletter/send",
};

export const outreachApiConfig = {
  baseUrl:
    process.env.REACT_APP_OUTREACH_API_URL ||
    "https://xbq2vyi68l.execute-api.us-east-1.amazonaws.com/dev",
  addContactPath:
    process.env.REACT_APP_OUTREACH_ADD_CONTACT_PATH ||
    "/outreach/add-contact",
  managePreferencesUrl:
    process.env.REACT_APP_MANAGE_SUBSCRIPTIONS_URL ||
    "/profile#subscriptions",
};
// Force rebuild
